export const createReactionResponse = () => ({
  createReaction: {
    object_type: 'content',
    created_at: -1,
    object_id: -1,
    reaction_type: 'like',
    user_id: -1,
    __typename: 'Reaction',
  },
});
